import { GQLError } from '../../apis/graphql/graphqlAPI';
import { RoutePath } from '../../constants';

const safeParse = <T>(str: string): T | null => {
  try {
    return JSON.parse(str) as T;
  } catch {
    return null;
  }
};

const handleGql403 = (error: unknown): void => {
  const errorMessage = error instanceof Error ? error.message : String(error);
  const parsed = safeParse<Partial<GQLError>>(errorMessage);

  if (parsed && Array.isArray(parsed.details)) {
    const error403 = parsed.details.find((item) => item.status === '403');
    if (error403) {
      window.location.href = RoutePath.FORBIDDEN;
      return;
    }

    throw new Error(parsed.message ?? errorMessage);
  }

  throw error instanceof Error ? error : new Error(errorMessage);
};

export default handleGql403;
